import { t } from '../utils/i18n';

export const apiKey = import.meta.env.VITE_BYTESCALE_API_KEY || '';
export const uploadBucket = import.meta.env.VITE_UPLOAD_FOLDER || '';

// UWAGA: Bytescale v4 (@bytescale/upload-widget 4.x) NIE obsługuje już `styles.customCSS`
// (typ UploadWidgetStyles zna tylko colors/fontSizes/fontFamilies/breakpoints). Cały wizualny
// redesign drop-zone (kompaktowa karta, ikona, akcent-link, linia formatów, chip pliku) siedzi
// w GLOBALNYM arkuszu `src/styles/uploadWidget.css` (importowanym w index.tsx), celującym w klasy
// `.upload-widget__*`. Tutaj podajemy widgetowi tylko obsługiwane tokeny kolorów.

// Light mode styles
export const sharedStyles = {
  colors: {
    primary: '#1a4d4d',
  },
};

// Dark mode styles for Bytescale upload widget
export const sharedStylesDark = {
  colors: {
    primary: '#1a4d4d',
    error: '#f87171',
    shade100: '#ffffff', // Light text for dark background
    shade200: '#e5e7eb', // Secondary text
    shade300: '#d1d5db', // Secondary text hover
    shade400: '#9ca3af', // Welcome text
    shade500: '#6b7280', // Modal close button
    shade600: '#374151', // Border
    shade700: '#242a33', // Progress indicator background
    shade800: '#1a1f26', // File item background
    shade900: '#111827', // Base dark
  },
};

// Function to get styles based on theme mode
export const getUploadStyles = (isDark: boolean) => (isDark ? sharedStylesDark : sharedStyles);

export const getSharedLocale = (): Record<string, string | boolean> => ({
  processingFile: t('upload.processingFile'),
  submitBtnLoading: t('upload.submitBtnLoading'),
  continueBtn: t('upload.continueBtn'),
  orDragDropFile: t('upload.orDragDropFile'),
  orDragDropFileMulti: t('upload.orDragDropFileMulti'),
  orDragDropImage: t('upload.orDragDropImage'),
  orDragDropImageMulti: t('upload.orDragDropImageMulti'),
  removeBtn: t('upload.removeBtn'),
  cancelBtn: t('upload.cancelBtn'),
  cancelPreviewBtn: t('upload.cancelPreviewBtn'),
  doneBtn: t('upload.doneBtn'),
  addAnotherFileBtn: t('upload.addAnotherFileBtn'),
  addAnotherImageBtn: t('upload.addAnotherImageBtn'),
  maxFilesReachedPrefix: t('upload.maxFilesReachedPrefix'),
  maxImagesReachedPrefix: t('upload.maxImagesReachedPrefix'),
  unsupportedFileType: t('upload.unsupportedFileType'),
  fileSizeLimitPrefix: t('upload.fileSizeLimitPrefix'),
  finishBtn: t('upload.finishBtn'),
  uploadFileBtn: t('upload.uploadFileBtn'),
  uploadFileMultiBtn: t('upload.uploadFileMultiBtn'),
  uploadImageBtn: t('upload.uploadImageBtn'),
  uploadImageMultiBtn: t('upload.uploadImageMultiBtn'),
});

// Deprecated: Use getSharedLocale() instead
export const sharedLocale = getSharedLocale();
